
































import { Component, Emit } from 'vue-property-decorator'
import { ceil, findIndex, isArray, toNumber } from 'lodash'
import { Sticky, DropdownMenu, DropdownItem } from 'vant'
import { getDistrictList } from '../../category.service'
import { TENANTGOODS, HASALLCATEGORYLIST } from '../../category.config'
import { SuperMixin } from '../../category.mixin'
import { divideNum } from '@utils/index'

import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

@Component({
  components: {
    [Sticky.name]: Sticky,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
})
export default class TabSelectComponent extends SuperMixin {
  district = ''
  selectedCategoryId = ''
  categoryIdSelect: any = []
  districtList = [{ text: '全部区域', value: '' }]
  btnNum = 2
  tabLat = TENANTGOODS
  tabLatSelectedIndex = 0
  otherCondition: any[] = [{ text: '距我最近', value: 'distance' }]
  otherConditionSelected = 'distance'

  @categoryModule.State categoryList!: any[]
  @categoryModule.State selfOperatedData!: any

  get noSelfOperated() {
    return !this.selfOperatedData || this.selfOperatedData?.spuList?.length === 0
  }

  get isTwo() {
    return this.btnNum === 2
  }
  get isThree() {
    return this.btnNum === 3
  }
  get isFour() {
    return this.btnNum === 4
  }
  get selectCategoryList() {
    return [{ text: '全部品类', value: '' }].concat(this.categoryList)
  }
  get hasCategoryList(): boolean {
    return (
      findIndex(HASALLCATEGORYLIST, (o: string) => {
        if (o && this.categoryId && o.length !== this.categoryId.length) {
          return divideNum(o) === divideNum(this.categoryId)
        } else {
          return o == this.categoryId
        }
      }) > -1
    )
  }
  created(): void {
    this.selectedCategoryId = `${this.categoryId}`.length === 8 ? `${this.categoryId}` : ''
    this.btnNum = 2 + toNumber(this.hasCategoryList)
    this.initData()
    this.changeCondition()
  }
  async initData(): Promise<any> {
    const res: any = await getDistrictList()
    if (res.DistrictList && isArray(res.DistrictList)) {
      const districtList = res.DistrictList.map((item: any) => {
        const { ID, NAME } = item
        return { text: NAME, value: ID }
      })
      this.districtList = this.districtList.concat(districtList)
    }
  }
  toSticky(): void {
    const tabSticky: HTMLElement = this.$refs.tabSticky as HTMLElement
    if (tabSticky) window.scrollTo(0, tabSticky.offsetTop + 8 * (ceil(document.body.clientWidth / 375, 1) + 0.1))
  }
  openDrop() {
    const tabSticky: HTMLElement = this.$refs.tabSticky as HTMLElement
    const compensationHeight = document.body.scrollHeight - tabSticky.offsetTop - document.body.clientHeight
    const appDom = document.querySelector('#app') as HTMLElement
    if (appDom) {
      appDom.style.minHeight = compensationHeight < 0 ? `${document.body.scrollHeight - compensationHeight + 10}px` : 'auto'
    }
  }
  closeDrop() {
    const appDom = document.querySelector('#app') as HTMLElement
    if (appDom) {
      appDom.style.minHeight = 'auto'
    }
  }
  changeTabLat(index: number) {
    if (this.tabLatSelectedIndex === index) return
    this.tabLatSelectedIndex = index
    const current = this.tabLat[index]
    this.btnNum = 2 + toNumber(this.hasCategoryList)
    if (current) {
      if (current.other) {
        this.otherCondition.unshift(current.other)
        ++this.btnNum
      } else {
        this.otherCondition.splice(0, 1)
      }
    }
    this.otherConditionSelected = 'distance'
    this.changeCondition()
  }
  changeOtherCondition(value: string): void {
    if (this.otherConditionSelected === value) return
    this.otherConditionSelected = value
    this.changeCondition({
      other: value,
    })
  }
  changeDistrict() {
    this.changeCondition({
      district: this.district,
    })
  }
  changeCategoryId() {
    this.changeCondition({
      categoryId: this.categoryId || '',
    })
  }

  @Emit()
  changeCondition(confition: any = {}) {
    let selectedCategoryId: string | string[] | undefined = this.selectedCategoryId || ''
    if (!selectedCategoryId) {
      selectedCategoryId = this.categoryIds
    } else {
      selectedCategoryId = [selectedCategoryId]
    }
    this.categoryIdSelect = selectedCategoryId
    const con = {
      ...confition,
      districtId: this.district,
      level4CategoryIds: selectedCategoryId,
      other: this.otherConditionSelected,
      tabCut: this.tabLat[this.tabLatSelectedIndex].value || '',
    }
    return con
  }
}
